"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FilledPhone = function (_a) {
    var setCanEditPhone = _a.setCanEditPhone, phone = _a.phone;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, "".concat(phone)),
        react_1.default.createElement("div", { onClick: setCanEditPhone, className: styles_module_scss_1.default.editIcon })));
};
exports.default = FilledPhone;
